
/* injects from baggage-loader */

export const balloons = [
    'Bem-vindo(a) à <b>Região Sul</b>!<br> O Sul é conhecido por suas <br> cidades históricas, suas colônias <br> europeias e, claro, pela <br> marcante culinária.',
    'Leia e faça seu pedido. Você deve <br> escolher um prato de cada <br> seção, e a conta deve totalizar, <br> no máximo, 50 reais.',
]


// WEBPACK FOOTER //
// ./src/app/pages/stage-two/stage-two.const.js